import { randOf, shuffle } from "../../helpers/generators.js";
import Element from "./Element.js";

/**
 * Compile from layout (array/object)
 *
 * @param {Array|Object} layout
 * @returns {Object} { generated, blocks, info }
 */
export default function Compile(layout) {
    const generated = [];
    const blocks = [];
    let info = {};
    let errors = [];

    (function recursion({ element, parent, isEven }, lvl) {
        lvl = lvl ?? 0;

        // Select one element from array - randomizing
        while (Array.isArray(element)) {
            element = randOf(element);
        }

        if (!element) {
            return null;
        }

        // Check
        if (element.hasOwnProperty("shuffle") && element.hasOwnProperty("children")) {
            errors.push("Element can have one of the values shuffle or children!");
            const e = new Error("Element can have one of the values shuffle or children!");
            e.errors = errors;
            throw e;
        }

        // Shuffle
        if (element.shuffle) {
            for (const element of shuffle(element.shuffle)) {
                recursion({ element, parent }, lvl);
            }
            return;
        }

        // Save Block (for anchors)
        if (element.id) {
            if (blocks.includes(element.id)) {
                errors.push(`BlockId already exists ${element.id}`);
                const e = new Error(`BlockId already exists ${element.id}`);
                e.errors = errors;
                throw e;
            }

            blocks.push(element.id);

            element.props = element.props ?? {};
            element.props._block = element.id;
        }

        // Save element info (for svg-background, ...)
        if (element.info) {
            if (element.info.constructor.name !== "Object") {
                errors.push("element.info is not Object");
                const e = new Error("element.info is not Object");
                e.errors = errors;
                throw e;
            }

            info = { ...info, ...element.info };
        }

        // Create element
        const _element = {
            id: element.id,
            name: element.name,
            props: element.props,
            // props: { ...element.props, evenOdd: element?.rules.evenOdd },
        };

        if (element.attrs) {
            _element.attrs = element.attrs;
        }

        const toParent = Element(_element);

        // -- Add childrens to element
        if (element.children) {
            const calcEven = element.rules && element.rules.evenOdd;
            let parent;
            let index = 0;
            for (const element of element.children) {
                parent = toParent.children = toParent.children ?? [];

                recursion(
                    {
                        element,
                        parent,
                        isEven: calcEven ? index % 2 === 0 : isEven,
                    },
                    lvl + 1
                );

                index++;
            }

            {
                /* let isEven;
                if (element.rules && element.rules.evenOdd) {
                    for (const child of toParent.children) {
                        isEven = toParent.children.indexOf(child) % 2 === 0;
                        child.props[isEven ? "even" : "odd"] = true;
                        child.props.intersect = true;
                    }
                } */
            }
        }

        // Append to parent
        parent.push(toParent);
    })({ element: layout, parent: generated });

    return { generated, blocks, info, errors };
}
